module.exports = __webpack_public_path__ + "static/contenzioso-3d2ade392d952bab33013feed51bb1a9.png";